import { Link } from 'react-router'
import { SuiteName } from '@signifyd/cypress'
import RunStatusTag from 'core/components/RunStatusTag/RunStatusTag'
import { ColumnType } from 'antd/es/table/interface'
import { RunManifestEntry } from 'lib/queries/useGetRuns/runs.types'
import PrLink from './PrLink'

export const getDashboardColumns = (
  suite: SuiteName
): Array<ColumnType<RunManifestEntry>> => {
  const suiteQuery = `?suite=${suite}`

  return [
    {
      title: 'Project Name',
      dataIndex: 'project',
      key: 'project',
      render: (project: string) => (
        <Link to={`/playwright/${project}/ci-runs${suiteQuery}`}>
          {project}
        </Link>
      ),
    },
    {
      title: 'Run Id',
      dataIndex: 'runId',
      key: 'runId',
      render: (runId: string, record) => (
        <Link to={`/playwright/${record.project}/${runId}${suiteQuery}`}>
          {runId}
        </Link>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      align: 'center',
      render: (_, record) => <RunStatusTag runStatus={record.status} />,
    },
    {
      title: 'Timestamp',
      dataIndex: 'datetime',
      key: 'datetime',
      render: (datetime: string) => new Date(datetime).toLocaleString(),
      sorter: (a, b) => {
        if (!a.datetime || !b.datetime) {
          return Infinity
        }

        return new Date(a.datetime).getTime() - new Date(b.datetime).getTime()
      },
      defaultSortOrder: 'descend',
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      // Branch/PR only exist for FE runs; QE runs aren't tied to a frontend PR.
      title: 'Branch',
      hidden: suite !== 'fe',
      dataIndex: 'branchName',
      key: 'branchName',
    },
    {
      title: 'Pull Request',
      hidden: suite !== 'fe',
      dataIndex: 'pullRequestNumber',
      key: 'pullRequestNumber',
      render: (prNumber: string) => <PrLink prNumber={prNumber} />,
    },
  ]
}
